module.exports = __webpack_public_path__ + "fonts/nunitosans-black-webfont.e4c249a.woff";